export default "__VITE_ASSET__zfvTl4j3__"